import { render, staticRenderFns } from "./VideobusterPlayer.vue?vue&type=template&id=53ad1ea3&"
import script from "./VideobusterPlayer.vue?vue&type=script&lang=ts&"
export * from "./VideobusterPlayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports